// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"f01650f7","113":"d2848f2b","142":"ee13d845","438":"c0739578","589":"a13532d1","648":"90eaa8b9"}[chunkId] + ".chunk.js";
};